const CLASSIFICATION_SECTION = 'doc_classifications';
const DOCUMENTS_SECTION = 'documents';
const CLASSIFICATION_ACTION_KEYS = ['view', 'create_edit', 'delete', 'share'];
const LINKED_VIEW_SECTIONS = [DOCUMENTS_SECTION, CLASSIFICATION_SECTION];

const actionByKey = (actions, key) =>
  (actions || []).find((action) => action?.key === key) || null;

/** Classifications manage their own actions. The catalog often ships with View only. */
export function withClassificationActions(sections) {
  const list = Array.isArray(sections) ? sections : [];
  const documentActions = list.find((section) => section.key === 'documents')?.actions || [];

  return list.map((section) => {
    if (section.key !== CLASSIFICATION_SECTION) return section;
    const current = section.actions || [];
    const actions = CLASSIFICATION_ACTION_KEYS.map((key) => (
      actionByKey(current, key) || actionByKey(documentActions, key) || { key }
    ));
    return { ...section, actions };
  });
}

/** Documents View and Classifications View stay on or off together. */
export function linkDocumentClassificationView(selected) {
  const next = { ...(selected || {}) };
  const documentsView = !!next[DOCUMENTS_SECTION]?.view;
  const classificationsView = !!next[CLASSIFICATION_SECTION]?.view;
  if (documentsView === classificationsView) return selected || {};
  if (documentsView || classificationsView) {
    next[DOCUMENTS_SECTION] = { ...(next[DOCUMENTS_SECTION] || {}), view: true };
    next[CLASSIFICATION_SECTION] = { ...(next[CLASSIFICATION_SECTION] || {}), view: true };
  }
  return next;
}

export function applyLinkedSectionView(selected, sectionKey, actionKey, checked) {
  const next = { ...(selected || {}) };
  const section = { ...(next[sectionKey] || {}) };
  section[actionKey] = checked;
  if (checked && actionKey !== 'view') section.view = true;
  if (!checked && actionKey === 'view') {
    Object.keys(section).forEach((key) => {
      section[key] = false;
    });
  }
  next[sectionKey] = section;

  if (!LINKED_VIEW_SECTIONS.includes(sectionKey)) return next;

  const viewOn = !!section.view;
  LINKED_VIEW_SECTIONS.forEach((key) => {
    if (key === sectionKey) return;
    const other = { ...(next[key] || {}) };
    if (viewOn) {
      other.view = true;
    } else if (actionKey === 'view') {
      Object.keys(other).forEach((action) => {
        other[action] = false;
      });
      other.view = false;
    }
    next[key] = other;
  });
  return next;
}
